// @ts-nocheck
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import "./utils/validate" //
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/gloable.css'
const baseURL = 'http://test-dev.welamp.cn'

Vue.prototype.$baseURL = baseURL
Vue.use(ElementUI);
Vue.config.productionTip = false

//限制按钮网络差时多次点击 点击事件@click换成btn-control
Vue.directive("btn-control", {
	// 插入dom 时做的事情
	inserted: function(el, bind) {
		el.addEventListener("click", () => {
			el.disabled = true;
			bind.value().then(res => {
				el.disabled = false;
			});
		});
	}
  });

new Vue({
	store,
	router,
	render: h => h(App)
}).$mount('#app')

var _hmt = _hmt || [];
window._hmt=_hmt;
(function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?cbbaca96c00887c7cb29fee1fab403a2";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();
